/**
 * #type.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
export var FormFieldType;
(function (FormFieldType) {
    /** STRING - Single-line string */
    FormFieldType[FormFieldType["STRING"] = 0] = "STRING";
    /** PARAGRAPH - Multi-line string */
    FormFieldType[FormFieldType["PARAGRAPH"] = 1] = "PARAGRAPH";
    /** NUMBER - Number input */
    FormFieldType[FormFieldType["NUMBER"] = 2] = "NUMBER";
    /** BOOLEAN - Checkbox, switch */
    FormFieldType[FormFieldType["BOOLEAN"] = 3] = "BOOLEAN";
    /** LIST - Collect multiple entries of a single type */
    FormFieldType[FormFieldType["LIST"] = 4] = "LIST";
    /** SELECTION - Provide a list of options for the user to choose from */
    FormFieldType[FormFieldType["SELECTION"] = 5] = "SELECTION";
    /** GROUP - Create a labeled subsection of the form with nested fields */
    FormFieldType[FormFieldType["GROUP"] = 6] = "GROUP";
    /** IMAGE - Image upload - value is a URL for the uploaded image */
    FormFieldType[FormFieldType["IMAGE"] = 7] = "IMAGE";
    FormFieldType[FormFieldType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(FormFieldType || (FormFieldType = {}));
export function formFieldTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "STRING":
            return FormFieldType.STRING;
        case 1:
        case "PARAGRAPH":
            return FormFieldType.PARAGRAPH;
        case 2:
        case "NUMBER":
            return FormFieldType.NUMBER;
        case 3:
        case "BOOLEAN":
            return FormFieldType.BOOLEAN;
        case 4:
        case "LIST":
            return FormFieldType.LIST;
        case 5:
        case "SELECTION":
            return FormFieldType.SELECTION;
        case 6:
        case "GROUP":
            return FormFieldType.GROUP;
        case 7:
        case "IMAGE":
            return FormFieldType.IMAGE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return FormFieldType.UNRECOGNIZED;
    }
}
export function formFieldTypeToJSON(object) {
    switch (object) {
        case FormFieldType.STRING:
            return 0;
        case FormFieldType.PARAGRAPH:
            return 1;
        case FormFieldType.NUMBER:
            return 2;
        case FormFieldType.BOOLEAN:
            return 3;
        case FormFieldType.LIST:
            return 4;
        case FormFieldType.SELECTION:
            return 5;
        case FormFieldType.GROUP:
            return 6;
        case FormFieldType.IMAGE:
            return 7;
        case FormFieldType.UNRECOGNIZED:
        default:
            return -1;
    }
}
